import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { SupplementaryEquipmentDetails } from '../model/supplementary-equipment-details';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceResponse } from '@sdbn/appclient';
import { Identity } from '@sdbn/appclient';
import { SupplementaryEquipment } from '../model/supplementary-equipment';

@Injectable({
  providedIn: 'root'
})
export class SupplementaryEquipmentService {

  constructor(private tmcHttpService: HttpService) { }

  getSupplementaryEquipment(): Observable<SupplementaryEquipment[]> {
    return this.tmcHttpService.postWithContext<SupplementaryEquipment[]>(environment.supplementaryEquipmentAdminEndpoint, {});
  }

  getSupplementaryEquipmentDetails(identity: Identity): Observable<SupplementaryEquipmentDetails> {
    return this.tmcHttpService.postWithContext<SupplementaryEquipmentDetails>(environment.supplementaryEquipmentAdminEndpoint + '/details', identity);
  }

  saveSupplementaryEquipment(se: SupplementaryEquipmentDetails): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.supplementaryEquipmentAdminEndpoint + '/save', se);
  }

  createSupplementaryEquipment(se: SupplementaryEquipmentDetails): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.supplementaryEquipmentAdminEndpoint + '/create', se);
  }

  deleteSupplementaryEquipment(identity: Identity): Observable<ServiceResponse> {
    return this.tmcHttpService.postWithContext<ServiceResponse>(environment.supplementaryEquipmentAdminEndpoint + '/delete', identity);
  }
}
